import React from 'react';
import _get from 'lodash.get';
import { connect } from 'react-redux';
import { updateFilter } from 'store/actions/search';
import Checkbox from 'common/forms/checkbox/Checkbox';

const adjustFilters = (filterKey, name, checked, checkboxGroup = [name], props) => {
  checkboxGroup.forEach((checkbox) => {
    const value = checkbox === name ? checked : false;
    props.updateFilter(filterKey, checkbox, value);

    if (props.onClick) {
      props.onClick(checked, name);
    }
  });
};

const FilterCheckboxes = ({ legend, options, filterKey, filters, checkboxGroup, ...props }) => (
  <div className="filters--checkboxes">
    {legend && <legend>{legend}</legend>}
    {options.map(({ name, displayName }) => (
      <Checkbox
        key={name}
        checked={_get(filters, `${filterKey}.${name}`) || false}
        onChange={({ target: { checked } }) => adjustFilters(filterKey, name, checked, checkboxGroup, props)}
      >
        {displayName}
      </Checkbox>
    ))}
  </div>
);

const mapStateToProps = ({ search: searchStore }) => ({
  filters: searchStore.filters,
});

const mapDispatchToProps = {
  updateFilter,
};

export default connect(mapStateToProps, mapDispatchToProps)(FilterCheckboxes);
